import { Route, Switch } from 'react-router-dom';
import React from 'react';
import UnauthRoute from "./util/UnauthRoute";
import NotFound from './base/NotFound';

import Calculator from './network/Calculator';
import Richlist from './network/Richlist';
import OasisPools from './network/OasisPools';
import NetworkStats from './network/NetworkStats';
import NetworkEvents from './network/NetworkEvents';
import NetworkStakeHistory from './network/NetworkStakeHistory';
import TopBlockSigners from './network/TopBlockSigners';

import Address from './address/Address';
import MyAccount from './address/MyAccount';
import Rewards from './address/Rewards';

import Events from './oasis/Events';
import OasisPool from './oasis/OasisPool';
import Delegates from './oasis/Delegates';
import PoolStats from './oasis/PoolStats';
// import OasisSignByHour from './oasis/OasisSignByHour';
// import OasisSignByDate from './oasis/OasisSignByDate';


export default ({ childProps }) => (
	<Switch>
		<UnauthRoute exact={true} path='/' component={OasisPools} props={childProps} />

		<UnauthRoute path='/pools/:selectedInd' component={OasisPools} props={childProps} />
		<UnauthRoute path='/pools' component={OasisPools} props={childProps} />

		<UnauthRoute path='/pool/:poolId' component={OasisPool} props={childProps} />

		<UnauthRoute path='/events/:poolId/:subType' component={Events} props={childProps} />
		<UnauthRoute path='/events/:poolId' component={Events} props={childProps} />
		<UnauthRoute path='/poolStats/:poolId' component={PoolStats} props={childProps} />
		<UnauthRoute path='/delegates/:poolId' component={Delegates} props={childProps} />

		<UnauthRoute path='/address/:address' component={Address} props={childProps} />
		<UnauthRoute path='/account/:address' component={MyAccount} props={childProps} />
		<UnauthRoute path='/account' component={MyAccount} props={childProps} />
		<UnauthRoute path='/rewards/:address' component={Rewards} props={childProps} />
		<UnauthRoute path='/rewards' component={Rewards} props={childProps} />

		<UnauthRoute path='/topSigners' component={TopBlockSigners} props={childProps} />
		<UnauthRoute path='/history' component={NetworkStakeHistory} props={childProps} />
		<UnauthRoute path='/networkStake' component={NetworkStakeHistory} props={childProps} />

		<UnauthRoute path='/networkEvents/:subType' component={NetworkEvents} props={childProps} />
		<UnauthRoute path='/networkEvents' component={NetworkEvents} props={childProps} />
		<UnauthRoute path='/richlist/:count' component={Richlist} props={childProps} />
		<UnauthRoute path='/richlist' component={Richlist} props={childProps} />
		<UnauthRoute path='/stats' component={NetworkStats} props={childProps} />
		<UnauthRoute path='/calc' component={Calculator} props={childProps} />
		{/* Finally, catch all unmatched routes */}
		<Route component={NotFound} />
	</Switch>
);

// <UnauthRoute path='/signByHour/:poolId' component={OasisSignByHour} props={childProps} />
// <UnauthRoute path='/signByHour' component={OasisSignByHour} props={childProps} />

// <UnauthRoute path='/sign/:poolId' component={OasisSignByDate} props={childProps} />
// <UnauthRoute path='/sign' component={OasisSignByDate} props={childProps} />



// WEBPACK FOOTER //
// ./src/DefaultRoutes.js